import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { getMeta } from '@atlassian/eoc-fetch';
export const withAIOpsPrefix = input => {
  const cloudId = getMeta('ajs-cloud-id');
  if (cloudId) {
    return getBooleanFF('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
  }
  return input;
};